import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {aShowDialog} from '@modifi/plugin-dialogs'

import BuyerList, {BuyerListProps} from './BuyerList'

import {PRE_UNDERWRITING_COMPANY_FINANCIALS} from '../../constants'
import {ROUTE_INTRO} from '../../../../../routes/constants'
import {selectBuyerSummaryData} from './selector'
import {aShowBuyerForm} from '../store/view'
import {PRE_UNDERWRITING_SUBMIT_CONFIRMATION_DIALOG} from '../../dialogs'
import {selectCompanyIsLocked, selectCompanyActivationStatus} from '../../../../../data/company'
import {aRemoveLoadingLimitForBuyer, getLoadingLimitsForBuyers} from '../store/loadingLimits'
import {aFetchSellerTradePartners} from '../../../../../data/seller-trade-partners'

const mapStateToProps = (
  state: Record<string, any>
): Pick<BuyerListProps, 'buyers' | 'companyIsLocked' | 'loadingLimits' | 'activationStatus'> => ({
  buyers: selectBuyerSummaryData(state),
  companyIsLocked: selectCompanyIsLocked(state),
  loadingLimits: getLoadingLimitsForBuyers(state),
  activationStatus: selectCompanyActivationStatus(state) || '',
})

const mapDispatchToProps = {
  showBuyerForm: aShowBuyerForm,
  redirectToCompanyFinancials: (): any =>
    aPush(ROUTE_INTRO, {page: PRE_UNDERWRITING_COMPANY_FINANCIALS}),
  onSubmit: (): any => aShowDialog(PRE_UNDERWRITING_SUBMIT_CONFIRMATION_DIALOG),
  fetchBuyers: aFetchSellerTradePartners,
  removeLoadingLimit: aRemoveLoadingLimitForBuyer,
}

export default connect(mapStateToProps, mapDispatchToProps)(BuyerList)
